// extracted by mini-css-extract-plugin
export var close = "AdBar-module--close--a2d0e";
export var container = "AdBar-module--container--6fd36";
export var root = "AdBar-module--root--03859";